import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }

import { ref, watch } from 'vue'
import { debounce } from 'lodash-es'
import { UiInput } from '@klausapp/ui-kit'
import { SearchIcon, XIcon } from '@klausapp/ui-kit/icons'
import { sanitize } from '@/utils/sanitize'


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    modelValue: {},
    small: { type: Boolean },
    dataTestid: {},
    debounceTimeout: { default: 0 },
    placeholder: {},
    shrinkablePlaceholder: { type: Boolean },
    light: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const val = ref(props.modelValue || '')

const emitUpdate = debounce((val) => emit('update:modelValue', sanitize(val)), props.debounceTimeout)

watch(val, () => emitUpdate(val.value))
watch(
  () => props.modelValue,
  () => (val.value = props.modelValue),
)

const clearInput = () => {
  val.value = ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createVNode(_unref(SearchIcon), { class: "pointer-events-none absolute h-full w-8 p-2 text-gray-50" }),
    _createVNode(_unref(UiInput), {
      modelValue: val.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((val).value = $event)),
      modelModifiers: { trim: true },
      "data-testid": _ctx.dataTestid,
      small: _ctx.small,
      light: _ctx.light,
      class: _normalizeClass([_ctx.small ? '!px-8' : '!px-9', !val.value && '!pr-2']),
      placeholder: _ctx.placeholder || _ctx.$t('universal.search'),
      "shrinkable-placeholder": _ctx.shrinkablePlaceholder,
      "aria-label": _ctx.placeholder || _ctx.$t('universal.search')
    }, null, 8 /* PROPS */, ["modelValue", "data-testid", "small", "light", "class", "placeholder", "shrinkable-placeholder", "aria-label"]),
    (val.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          onClick: clearInput
        }, [
          _createVNode(_unref(XIcon), { class: "hover:text-gray-60 absolute right-0 top-0 h-full w-8 cursor-pointer p-2 text-gray-50" })
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})